import { connect } from 'react-redux';
import { selectUserCountryCode } from '@noths/polaris-client-user-configuration';

import { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalPrice } from 'src/redux/personalisation';
import { Klarna } from '../components/Klarna';

const mapStateToProps = (state: ReduxApplicationState) => ({
  countryCode: selectUserCountryCode(state),
  totalPrice: selectTotalPrice(state),
});

export const KlarnaContainer = connect(mapStateToProps)(Klarna);
